import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { DocumentType } from '../../../../common/constants/documentType';
import { Resource } from '../../../../common/constants/resource';
import { TaskState } from '../../../../common/constants/states';
import ElementLocators from '../../../../common/ElementLocators';
import { FeatureFlagsContext } from '../../../../common/featureFlagsWrapper';
import { ITask } from '../../../tasks/interfaces/ITask';
import styles from '../../styles.module.scss';
import { RetryableEvidenceItem } from '../components/RetryableEvidenceItem';
import { TaskDetailsItem } from '../components/TaskDetailsItem';

export const DisclosureDetail = ({
  task,
  uploadHandler,
  downloadHandler,
  taskStateHandler,
  deleteHandler,
  policyId,
}: {
  task: ITask;
  uploadHandler: (
    existingTaskData: ITask,
    data: FormData,
    type: string,
  ) => void;
  downloadHandler: (uri: string, fileName: string) => void;
  deleteHandler: (
    existingTaskData: ITask,
    documentId: number,
    reason: string,
  ) => void;
  taskStateHandler: (taskId: number, state: TaskState, reason?: string) => void;
  policyId: number;
}) => {
  const { flags } = useContext(FeatureFlagsContext);
  const { isQeInterviewQaEnabled } = flags;

  return (
    <div data-label={ElementLocators.LOCATOR_DISCLOSURE_SECTION}>
      <RetryableEvidenceItem
        task={task}
        documentType={DocumentType.DISCLOSURE}
        title={Resource.TASK_TITLE_DISCLOSURE}
        downloadHandler={downloadHandler}
        uploadHandler={uploadHandler}
        deleteHandler={deleteHandler}
        taskStateHandler={taskStateHandler}
        canDeleteFile={false}
      />
      {isQeInterviewQaEnabled && (
        <TaskDetailsItem
          leftItem={Resource.TASK_DETAILS_TITLE_QE_INTERVIEW_QA}
          rightItem={
            <Link
              target="_blank"
              to={`/workbench/qna/policy/${policyId}`}
              className={styles.Document}
            >
              {`application_qna_${policyId}`}
            </Link>
          }
        />
      )}
    </div>
  );
};
